import React, {createContext, useEffect, useState} from 'react';
import './index.css';
import Header from "../header/Header";
import {useTonWallet} from "@tonconnect/ui-react";
import axios from "axios";
import {baseUrl} from "../../api/network";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import {useShallowPickSelector} from "../../redux";

export const HeaderContext = createContext(null);

const Layout = (props) => {
    const wallet = useTonWallet();
    const {children} = props;
    const [pointRect, setPointRect] = useState(null);
    const {tgUser} = useShallowPickSelector('user', ['tgUser'])

    const setPointRectFn = (value) => {
        setPointRect(value)
    }

    useEffect(() => {
        const isWalletConnected = localStorage.getItem('isWalletConnected')
        if (wallet && !isWalletConnected) {
            sendWalletRequestFn()
        }
        if (!wallet) {
            localStorage.removeItem('isWalletConnected');
        }
    }, [wallet])

    const sendWalletRequestFn = () => {
        const headers = {
            'Content-Type': 'application/json',
        }

        axios.get(`${baseUrl}/wallet/connect?user_tg_id=${tgUser?.id}&wallet_addr=${wallet.account?.address}`,{headers})
            .then(response => {
                if (response.data.status === '1') {
                    // setSliderData(response.data.data)
                    localStorage.setItem('isWalletConnected', 'true')
                } else {
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 9});
                }
            })
            .catch(() => {
                toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 10});
            })
    }

    return (
        <HeaderContext.Provider
            value={{pointRect, setPointRectFn}}
        >
            <div className="layout-container">
                <Header />
                <div className="children-container">
                    {children}
                </div>
            </div>
        </HeaderContext.Provider>
    );
}

export default Layout
